/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sms_Last_StatusInputs */

const cs_sms_last_status = /** @type {(inputs: Sms_Last_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poslední stav`)
};

const en_sms_last_status = /** @type {(inputs: Sms_Last_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last status`)
};

/**
* | output |
* | --- |
* | "Last status" |
*
* @param {Sms_Last_StatusInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const sms_last_status = /** @type {((inputs?: Sms_Last_StatusInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sms_Last_StatusInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sms_last_status(inputs)
	return cs_sms_last_status(inputs)
});